import type { FlatpageDto } from '@features/legal/api/flatpages.dto'
import { mapFlatpageDto } from '@features/legal/api/flatpagesMapper'
import type { LegalPage } from '@features/legal/types'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const flatpagesApi = {
  getPage(params: { city: string; path: string }) {
    return useNuxtApi<FlatpageDto, LegalPage>('/api/flatpages', {
      query: {
        city: params.city,
        path: params.path,
      },
      transform: mapFlatpageDto,
    })
  },
}
